import { Button, Spinner } from "reactstrap";
import { toast } from "../../../../../core/helpers/message-helper";
import { obtenerConvenciones } from "../../../../NominaTurnos/services/nomina-turnos-service";
import {
    crearImagenDesdeElemento,
    exportarCuadroConvenciones,
} from "../../../helpers/exportar-convenciones-helper";
import { useState } from "react";

const BotonImprimirCuadroTurno = () => {
    const [cargando, setCargando] = useState(false);

    const exportarCuadroDeTurnos = async () => {
        try {
            setCargando(true);
            const resp = await obtenerConvenciones();
            if (!resp.status) toast.error(resp.message);

            const celdasAcumuladosHoras = document.querySelectorAll(
                ".celda-acumulado-horas"
            );

            const celdasAcumuladosTurnos = document.querySelectorAll(
                ".celda-acumulado-turnos"
            );

            celdasAcumuladosHoras.forEach(celda => celda.style.display = 'none')
            celdasAcumuladosTurnos.forEach(celda => celda.style.display = 'none')

            crearImagenDesdeElemento(
                document.getElementById("cuadro-turnos"),
                "cuadro-de-turnos.jpg"
            );

            celdasAcumuladosHoras.forEach(celda => celda.style.display = '')
            celdasAcumuladosTurnos.forEach(celda => celda.style.display = 'inline-block')

            if (!resp.status) return;
            const turnos = resp.data ?? [];
            exportarCuadroConvenciones(turnos);
            toast.success("Descargando imagen...");
        } catch (error) {
            toast.error(
                "Ha ocurrido un error al imprimir la imagen del cuadro de turnos"
            );
        }

        setCargando(false);
    };

    return (
        <Button
            title="Exportar Cuadro de Turnos a JPG"
            className="m-1"
            color="primary"
            onClick={exportarCuadroDeTurnos}
            disabled={cargando}
        >
            {cargando ? (
                <Spinner size="sm" />
            ) : (
                <i className="fas fa-image"></i>
            )}
        </Button>
    );
};

export default BotonImprimirCuadroTurno;
